const DList = [
    {
        id:1,
        name:"D1",
        isAvailable:false
    },
    {
        id:2,
        name:"D2",
        isAvailable:false
    },
    {
        id:3,
        name:"D3",
        isAvailable:false
    },
    {
        id:4,
        name:"D4",
        isAvailable:false
    }, {
        id:5,
        name:"D5",
        isAvailable:false
    }, {
        id:6,
        name:"D6",
        isAvailable:false
    }, {
        id:7,
        name:"D7",
        isAvailable:false
    }, {
        id:8,
        name:"D8",
        isAvailable:false
    }, {
        id:9,
        name:"D9",
        isAvailable:false
    }, {
        id:10,
        name:"D10",
        isAvailable:false
    }, {
        id:11,
        name:"D11",
        isAvailable:false
    }, {
        id:12,
        name:"D12",
        isAvailable:false
    }, {
        id:13,
        name:"D13",
        isAvailable:false
    },
    {
        id:14,
        name:"D14",
        isAvailable:false
    },
    {
        id:15,
        name:"D15",
        isAvailable:false
    },
    {
        id:16,
        name:"D16",
        isAvailable:false
    },
    {
        id:17,
        name:"D17",
        isAvailable:false
    },
    {
        id:18,
        name:"D18",
        isAvailable:false
    },
    {
        id:19,
        name:"D19",
        isAvailable:false
    },
    {
        id:20,
        name:"D20",
        isAvailable:false
    }
]

export {DList}